/**
 * URLクエリパラメータの定数
 */

/**
 * 選考管理追加モードを示すクエリパラメータの値
 */
export const QUERY_MODE_ADD_MANAGEMENT = 'add-management';
